module.exports = __webpack_public_path__ + "static/media/refercode_mobile.d24682a6.png";